module.exports = __webpack_public_path__ + "static/media/night.d4a69b3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/night.png
// module id = 965
// module chunks = 0